import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@trillion/auth";
import { SignInForm } from "@trillion/ui/components/sign-in-form";

export function LoginPage() {
  const { login, loginWithPassport } = useAuth();
  const navigate = useNavigate();
  const [ssoHint, setSsoHint] = useState<string | null>(null);

  async function handleSubmit(email: string, password: string) {
    try {
      await login(email, password);
      navigate("/", { replace: true });
    } catch (err) {
      const code = (err as Error & { code?: string }).code;
      if (code === "passport_login_required") {
        setSsoHint((err as Error).message ?? "This account uses Trillion Passport. Please use the SSO option.");
      }
    }
  }

  return (
    <SignInForm
      title="Help Admin"
      description="Sign in to administer Help"
      showSsoButton
      onSsoClick={loginWithPassport}
      ssoHint={ssoHint}
      onSubmit={handleSubmit}
    />
  );
}
